import {
  TCsvQuoteCharacterTranslations,
} from './select-csv-quote-char.ts';

const translations: TCsvQuoteCharacterTranslations = {
  single_quote: 'Jednoduché úvodzovky',
  double_quote: 'Dvojité úvodzovky',
};

export default {
  placeholder: 'Vyberte štýl úvodzoviek',
  exampleText: 'môj text',
  label: 'Znak úvodzovky',
  options: translations,
};
